export default __webpack_public_path__ + "static/test-coverage-f06a9a1251ef4a5b04ce37c02cd16380.png";